import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { SKILLS_DATA } from '../constants/skills';
import './SkillsSection.css';

const SkillsSection: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="skills-section">
      <div className="skills-header">
        <h2>{t('skills.title')}</h2>
        <p>{t('skills.description')}</p>
      </div>

      <div className="skills-overview">
        <div className="skill-stats">
          <div className="stat-item">
            <span className="stat-number">10+</span>
            <span className="stat-label">{t('skills.experience')}</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">20+</span>
            <span className="stat-label">{t('skills.technologies')}</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">50+</span>
            <span className="stat-label">{t('skills.projects')}</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">{t('skills.passion')}</span>
          </div>
        </div>
      </div>

      <div className="skills-categories">
        {SKILLS_DATA.map((category, categoryIndex) => (
          <div key={categoryIndex} className="skill-category">
            <h3 className="category-title">{t(category.name)}</h3>
            <div className="skills-grid">
              {category.skills.map((skill, skillIndex) => (
                <div key={skillIndex} className="skill-tag">
                  <span className="skill-name">{skill.name}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="certifications">
        <h3>{t('skills.certifications')}</h3>
        <div className="cert-grid">
          <div className="cert-item">
            <h4>{t('skills.cert.safe')}</h4>
            <p>{t('skills.cert.safe.status')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillsSection;